import {BrandedContentAdsPartnership} from '@/types/brandedContentAdsPartnership';
import api from '../index';

interface BrandedContentAdsPartnershipQueryParams {
  brand_id: string;
  include?: string;
}

const brandedContentAdsPartnershipFetchers = {
  list: (params: BrandedContentAdsPartnershipQueryParams) =>
    api.get<{data: BrandedContentAdsPartnership[]}>(
      '/branded_content_ads_partnerships',
      {params}
    ),
};

export default brandedContentAdsPartnershipFetchers;
